

































import { Nav, Popups, ScrollToTop } from '@/components';
import { GCoinsNav } from '@/components/gcoins';
import { Notifications } from '@/components/notifications';
import { Guides } from '@/components/guides';
import { GeekInfo } from '@/components/dashboard';
import { Geek, Theme } from '@/models';
import CookieLaw from 'vue-cookie-law';
import Vue from 'vue';

export default Vue.extend({
  name: 'App',
  beforeCreate(): void {
    const currentTheme = this.$store.state.themes.current;
    document.body.style.backgroundImage = `url('${currentTheme.backgroundImage}')`;
  },
  components: {
    GCoinsNav,
    Nav,
    Notifications,
    ScrollToTop,
    Guides,
    GeekInfo,
    Popups,
    CookieLaw,
  },
  computed: {
    isComponentVisible(): boolean {
      const exceptions = [
        'error-page',
        'access-denied-page',
        'kitchen-tv',
        'account-sign-in',
        'account-registration',
        'account-forgot-password',
        'account-reset-password',
        'account-sign-out',
        'account-confirm-email',
        'account-change-email',
      ];
      return !!this.$route.name && !exceptions.includes(this.$route.name);
    },
    geek(): Geek {
      return this.$store.state.geek.current;
    },
  },
  mounted() {
    const el = document.body;
    el.classList.add(this.currentPageName());
  },
  destroyed() {
    const el = document.body;
    el.classList.remove(this.currentPageName());
  },
  methods: {
    currentPageName(): string {
      return `page-${this.$route.name}`;
    },
  },
});
